import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import hasLoginRegisterLink from 'lib/has-login-register-link'

const BannerCTA = ({ data, theme }) => {
  const router = useRouter()
  if (!data.ctaText) {
    return false
  }
  const { features } = useSelector((state) => state.features)
  const isPfeAuthenticated = features['enable_pfe_authentication'] &&
  features['enable_pfe_authentication'].enabled
  return (
    <Box
      alignItems='center'
      as='a'
      bg={theme.ctaBackgroundColor || 'brand'}
      boxShadow='site'
      color={theme.ctaTextColor || 'white'}
      d='inline-flex'
      fontFamily='body'
      fontSize='body'
      fontWeight='bold'
      href={(hasLoginRegisterLink(data.ctaLink) && isPfeAuthenticated && router.asPath !== '/') ? `${data.ctaLink}?next=${router.asPath}` : data.ctaLink}
      px={8}
      py={4}
      rounded='site'
      textDecoration='none'
      target={data.openInNewTab ? '_blank' : '_self'}
      _hover={{
        bg: theme.ctaBackgroundHoverColor || theme.ctaBackgroundColor || 'brand',
        color: theme.ctaTextHoverColor || theme.ctaTextColor || 'white'
      }}
      className='banner-button'
      aria-label={data.ctaText}
    >
      {data.ctaText}
    </Box>
  )
}

BannerCTA.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object
}

export default BannerCTA
